module.exports = __webpack_public_path__ + "d6ef40e7afb5c761215ef5f26ec8a0a3.jpg";